/* eslint-disable max-len */
import {Progress, Space, Flex} from 'antd';
import React from 'react';

import mods from '../../../assets/mods.png';
import ques from '../../../assets/ques.png';

const QuestionnaireHead: React.FC<{
  headDetails: {
    imageUrl: string;
    title: string;
    description: string;
    noOfModules: number;
    answeredQuestions: number;
    totalQuestions: number;
  };
  data: any;
}> = ({headDetails, data}) => {
  return (
    <Flex style={{height: '100%'}}>
      <Flex style={{maxHeight: '100%', flex: '1'}}>
        <img
          src={headDetails.imageUrl}
          style={{width: '100%', maxHeight: '100%'}}
        />
      </Flex>
      <Flex style={{padding: '20px', maxHeight: '100%', flex: '2'}}>
        <Space direction="vertical" size="large">
          <span style={{fontSize: 20}}>{headDetails.title}</span>
          <div>{headDetails.description}</div>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
              flexWrap: 'nowrap'
            }}
          >
            <div style={{width: '50%'}}>
              Reporting Progress
              <Progress
                percent={data?.completion ?? 0}
                strokeColor="#3BB3C1"
                trailColor="#DDF7FA"
              />
            </div>

            <Flex vertical={false} style={{alignItems: 'center'}}>
              <Flex justify="center" align="center">
                <img
                  className="img"
                  id="mods"
                  src={mods}
                  alt="Logo"
                  width={36}
                />
              </Flex>
              <div style={{paddingLeft: '1rem'}}>
                <b>{data?.modules ?? 0}</b>
                <div>No. of Modules</div>
              </div>
            </Flex>

            <Flex vertical={false} style={{alignItems: 'center'}}>
              <Flex justify="center" align="center">
                <img
                  className="img"
                  id="ques"
                  src={ques}
                  alt="Logo"
                  width={36}
                />
              </Flex>
              <div style={{paddingLeft: '1rem'}}>
                <b>{`${data?.questionsAnswered ?? 0}/${
                  data?.totalQuestions ?? 0
                }`}</b>
                <div>Answered Questions</div>
              </div>
            </Flex>
          </div>
        </Space>
      </Flex>
    </Flex>
  );
};

export default QuestionnaireHead;
